import { render, staticRenderFns } from "./DomainSetup.vue?vue&type=template&id=242fe4d0&"
import script from "./DomainSetup.vue?vue&type=script&lang=ts&"
export * from "./DomainSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports